import { ModalProps } from "./types/modalProps";
import './modal.scss';
import { AdditionalIcon } from "../shared/additionalIcon/additionalIcon";
import Portal from "../shared/portal/portal";
import { ReactComponent as close } from '../../icons/close.svg';
import Spinner from "../spinner/spinner";
import { ClassNameSpinner } from "../spinner/types/spinnerProps";
import { useEffect, useRef } from "react";

const Modal = (props: ModalProps) => {
    const containerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        setTimeout(() => {
            containerRef.current?.focus();
        }, 0);
    }, []);
    
    const clickAction = () => {
        props.onClose();
    }

    const renderActionBtns = () => {
        if (hasActionBtns()) {
            return <div className="modalBtns">
                {props.actionBtns}
            </div>
        }
        return null;
    }

    const hasActionBtns = () => {
        return props?.actionBtns && props.actionBtns?.length > 0;
    }

    const getTemplate = () => {
        return hasActionBtns() ? "64px auto 52px" : "64px auto" ;
    }

    const keyboardNavClose = (event: any) => { 
        // Escape
        return event.keyCode === 27 && clickAction(); 
    }

    return (
        <Portal>
            <div tabIndex={-1} onKeyDown={keyboardNavClose} ref={containerRef}>
                <div className="modalBackground"></div>
                <div className="modalContent">
                    <div className="modal" style={{ width: props.width, height: props.height,  gridTemplateRows: getTemplate() }}>
                        {props.title && <div className="modalHeader">
                            <div className="modalTitle">
                                {AdditionalIcon(props.titleIcon, props.iconStyle, props.iconClass)}<h2>{props.title}</h2>
                            </div>
                            <button onClick={clickAction} title="Zamknij" className="closeBtn">{AdditionalIcon(close, {fill: "#453F3A"})}</button>
                        </div>}
                        {props.loading && <Spinner isMist={true} spinnerClass={ClassNameSpinner.Big} />}
                        <div className={props.bodyClassName ? props.bodyClassName : "modalBody"}>
                            {props.children}
                        </div>
                        {renderActionBtns()}
                        {props.footerNode && <div className="modalFooter body-txt-medium">
                            {props.footerNode}
                        </div>}
                    </div>
                </div>
            </div>
        </Portal>
    )
}

export default Modal;